import styled from 'styled-components'

export const Wrapper = styled.div``

export const LabelContainer = styled.div`
  margin-top: 16px;
  margin-bottom: -12px;
`
